import React from 'react';
import { useParams } from 'react-router-dom';
import senerfiBlanco from '../assets/images/senerfiblanco.png';
import BrandCopyright from '../Components/Common/BrandCopyright';
import TransportesPanel from './modules/TransportesPanel';

export default function Transportes() {
  const { location } = useParams();

  const handleBrandClick = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header tipo inicio de página con logo */}
      <div className="w-full shadow-md" style={{ backgroundColor: '#F07E2D' }}>
        <div className="max-w-6xl mx-auto flex items-center h-14 px-4">
          <img src={senerfiBlanco} alt="Senerfi" className="h-8 w-auto cursor-pointer" onClick={handleBrandClick} />
        </div>
      </div>

      {/* Contenido principal */}
      <div className="p-6 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-8 max-w-xl w-full">
          <TransportesPanel location={location} />
        </div>
      </div>

      {/* Pie de página reutilizable */}
      <BrandCopyright />
    </div>
  );
}
